import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { IMessagingSender } from 'src/app/models/IMessaging';
import { ActiveserviceService } from 'src/app/Services/ActiveUsers/activeservice.service';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';


@Component({
  selector: 'app-providers-list',
  templateUrl: './providers-list.component.html',
  styleUrls: ['./providers-list.component.css']
})
export class ProvidersListComponent implements OnInit {
  ProvidersListForm: FormGroup;
  public roles: IUserDetails[];
  public providersDocList: IUserDetails[];
  public rxReqDetails: IMessagingSender;
  constructor(private formBuilder: FormBuilder
    , private sharedService: SharedService
    , private activeserviceService: ActiveserviceService
    , private toastr: ToastrService
    , public dialogRef: MatDialogRef<ProvidersListComponent>
    , @Inject(MAT_DIALOG_DATA) public data: IMessagingSender) {
    this.rxReqDetails = this.data;
  }
  
  ngOnInit() {
    this.ProvidersListForm = this.formBuilder.group({
      transforUser: [''],
    });
    this.getAllProviders();
  }

  getAllProviders() {
    this.sharedService.getAllUsersByRole("Doctor").subscribe(data => {
      this.providersDocList = data;
    });
  }

  onSubmit() {
    if(this.ProvidersListForm.value.transforUser != ""){
      var result = this.ProvidersListForm.value.transforUser;
      this.dialogRef.close(result);
    }else{
      this.toastr.warning("Please select any provider");
      return;
    }
    
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
}

